module.exports = __webpack_public_path__ + "images/stickers/taco-sleeping@2x.58551b69c73b0c3abe12.png";